import Call from '../Call';

const Stats = {
    get() {
        return Call(`stats`);
    }
}

export default Stats;


// WEBPACK FOOTER //
// ./src/services/API/components/Stats.js